<template>
  <div class="order-link-person module" :id="moduleData.itemCode" style="padding-bottom: 20px;" :class="{'no-login': !isLogin}">
    <el-form class="" :model="form" :rules="rules" ref="form" label-width="165px"  label-position="right" v-if="formConfig.length">
      <div class="module-label">
        {{moduleData.itemName}}
        <template v-if="!isCs&&!isLogin">
          <el-button class="login-btn" type="primary" @click="dialogVisible = true">已有账号登录</el-button>
          <span class="login-tips">登录后，可导入上次申请表信息</span>
        </template>
        <span class="expand-btn" @click="changeSpecExpand(!isExpand)">
          <img :src="isExpand ? closeIcon : expandIcon" alt="">
          {{!isExpand ? '展开' : '收起'}}
        </span>
      </div>
      <el-row class="apply-info-form" :gutter="37">
        <el-col :span="12">
          <el-form-item prop="companyNameCn" :label="configByCode.companyNameCn.attrName" :class="{ 'is-required': !isCs }">
            <el-popover placement="bottom-start" trigger="manual" v-model="titleTipsVisible" width="379" v-if="isCs">
              <div style="color:#ca4300;height:100px;">请输入至少3个文字，系统将自动匹配公司信息</div>
              <el-autocomplete slot="reference" :maxlength="configByCode.companyNameCn.fillLen" style="width: 100%;" ref="autocomplete"
                               v-model="form.companyNameCn" :fetch-suggestions="querySearchAsync" @select="handleSelect" :placeholder="configByCode.companyNameCn.fillNotice"
                               highlight-first-item :trigger-on-focus="false" @focus="titleFocus" @blur="titleTipsVisible = false"
                               @input="titleFocus" :disabled="disabledAll" popper-class="company-popper">
                <template slot-scope="{ item }">
                  <div class="autocomplete-item">
                    <span class="autocomplete-item-name" v-html="item.customerNameCn || '空'"></span>
                    <span class="autocomplete-item-org">{{ item.siteInfo.map(v => v.organizationName).join(",") }}</span>
                    <span class="autocomplete-item-address">{{ item.addressCn }}</span>
                    <span class="autocomplete-item-date">{{ item.createdDate }}</span>
                  </div>
                </template>
              </el-autocomplete>
            </el-popover>
            <el-input v-model="form.companyNameCn" :maxlength="configByCode.companyNameCn.fillLen" :placeholder="configByCode.companyNameCn.fillNotice" :disabled="disabledAll" v-else></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="companyAddressCn" :label="configByCode.companyAddressCn.attrName" :class="{ 'is-required': !isCs }">
            <el-input :placeholder="configByCode.companyAddressCn.fillNotice" v-model="form.companyAddressCn" :maxlength="configByCode.companyAddressCn.fillLen" :disabled="disabledAll"></el-input>
          </el-form-item>
        </el-col>
        <template v-if="isExpand">
          <el-col :span="12">
            <el-form-item prop="companyNameEn" :label="configByCode.companyNameEn.attrName" :class="{ 'is-required': reportLuaCode && reportLuaCode !== 'ZN' && !isCs }">
              <el-input :placeholder="configByCode.companyNameEn.fillNotice" v-model="form.companyNameEn" :maxlength="configByCode.companyNameEn.fillLen" :disabled="disabledAll"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="companyAddressEn" :label="configByCode.companyAddressEn.attrName" :class="{ 'is-required': reportLuaCode && reportLuaCode !== 'ZN' && !isCs }">
              <el-input :placeholder="configByCode.companyAddressEn.fillNotice" v-model="form.companyAddressEn" :maxlength="configByCode.companyAddressEn.fillLen" :disabled="disabledAll"></el-input>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <div class="divider"></div>
      <el-row class="link-info-form">
        <el-col :span="8">
          <el-form-item prop="linkPerson" :label="configByCode.linkPerson.attrName">
            <el-input :placeholder="configByCode.linkPerson.fillNotice" v-model="form.linkPerson" :maxlength="configByCode.linkPerson.fillLen" :disabled="disabledAll || linkDisabled || (isLogin&& userInfo &&!!userInfo.userName)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="linkPhone" :label="configByCode.linkPhone.attrName">
            <el-input :placeholder="configByCode.linkPhone.fillNotice" v-model="form.linkPhone" :maxlength="configByCode.linkPhone.fillLen" :disabled="disabledAll || linkDisabled || (isLogin&& userInfo &&!!userInfo.userPhone)"></el-input>
            <el-tooltip class="item" effect="dark" content="手机号将作为账号接收验证码" placement="top" v-if="!isLogin">
              <img class="item-tips" src="../../../assets/images/apply/tips.png" alt="">
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="linkEmail" :label="configByCode.linkEmail.attrName" :class="{'is-required': configByCode.linkEmail.isMust}">
            <el-input :placeholder="configByCode.linkEmail.fillNotice" v-model="form.linkEmail" :maxlength="configByCode.linkEmail.fillLen" :disabled="disabledAll || linkDisabled || (isLogin && userInfo&&!!userInfo.userEmail)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="false">
          <el-form-item>
            <el-button class="add-btn" @click="addCc" v-if="form.orderLinkList.length < 3 && !disabledAll" :disabled="disabledAll">+ 添加联系邮箱</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-for="(item, index) in form.orderLinkList" :key="index" class="link-info-form">
        <el-col :span="8">
          <el-form-item label="联系人姓名">
            <el-input placeholder="" v-model="item.linkName" maxlength="25" :disabled="disabledAll"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :prop="`orderLinkList.${index}.linkEmail`" label="电子邮箱" :rules="emailRule" class="is-required">
            <el-input placeholder="" v-model="item.linkEmail" maxlength="80" :disabled="disabledAll"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-button type="text" style="margin-left: 23px;" class="del-btn" @click="delCc(index)" :disabled="disabledAll" v-if="!disabledAll">删除</el-button>
        </el-col>
      </el-row>
    </el-form>
    <!--  登录即注册弹窗-->
    <el-dialog :visible.sync="dialogVisible"
               width="540px"
               :append-to-body='true'
               custom-class="apply-login"
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <login-merge
        :env="commonProps.env"
        :successCallback="loginEmit"
        :memberUrl="memberUrl"
        :parameter="parameter"></login-merge>
    </el-dialog>
  </div>
</template>

<script>
import LoginMerge from "src/components/loginMerge/index.vue";
import { applyMixins } from "src/components/application/components/mixin";
import expandIcon from '../../../assets/images/spec-expand.png'
import closeIcon from '../../../assets/images/spec-close.png'
import {emailReg} from "utils";

export default {
  name: "ApplyInfo",
  components: {
    LoginMerge
  },
  props: {
  },
  mixins: [applyMixins],
  data() {
    return {
      expandIcon,
      closeIcon,
      dialogVisible: false,
      form: {
        companyNameCn: '',
        companyAddressCn: '',
        companyNameEn: '',
        companyAddressEn: '',
        linkPerson: '',
        linkEmail: '',
        linkPhone: '',
        orderLinkList: [],
      },
      codeLoading: false,
      timer: null,
      seconds: 59,
      isCodeOpen: '1',
      captchaAppId: '192302431',
      orderNo: '',
      parameter:{
        regSource:'member',
        regMode: 'USER_REG'
      },
      memberUrl: '',
      titleTipsVisible: false,
      reloadUserInfo: false,
      isExpand: false,
      configByCode: {}
    }
  },
  computed: {
    rules() {
      const required = { required: true, message: '必填项' }
      const linkEmail = [{ pattern: emailReg, message: '请输入正确的邮箱' }]
      if (this.configByCode.linkEmail && this.configByCode.linkEmail.isMust) {
        linkEmail.push(required)
      }
      return {
        companyNameCn: [this.required],
        companyAddressCn: [this.required],
        companyNameEn: [this.requiredEn, this.validatorEn],
        companyAddressEn: [this.requiredEn, this.validatorEn],
        linkPerson: [required],
        linkEmail,
        linkPhone: [required, this.phoneRule],
      }
    },
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const configObj = val.find(v => v.areaCode === 'application') || {}
        const configArr = configObj.attrs || []
        this.configByCode = this.getFormConfigByCode(configArr)
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
        if (val) {
          if (this.moduleData.sourceFormatJson) {
            this.form = this.formatByJson(val, this.moduleData.sourceFormatJson)
          } else {
            this.form = JSON.parse(JSON.stringify(val))
          }
        }
      },
      immediate: true
    },
    userInfo: {
      handler(val) {
        if (val && this.reloadUserInfo) {
          this.form.linkPerson = val.userName || val.userNick
          this.form.linkEmail = val.userEmail
          this.form.linkPhone = val.userPhone
        }
      }
    },
    form: {
      handler(val) {
        this.$emit('update:applyInfoData', val)
      },
      deep: true,
      immediate: true
    },
    reportLuaCode: {
      handler(val) {
        if (val !== 'ZN') {
          this.isExpand = true
          if (!this.form.companyAddressEn || !this.form.companyNameEn) {
            this.goAnchor('ApplyInfo')
          }
        }
      }
    },
    disabledAll: {
      handler(val) {
        if (val) this.changeSpecExpand(true)
      },
      immediate: true
    }
  },
  mounted() {
    if (!this.isCs && !this.isLogin) {
      /* 引用腾讯盾SDK */
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
      document.body.appendChild(s);
    }
    this.memberUrl = location.origin
  },
  methods: {
    goAnchor(selector, time) {
      const second = time || 500
      // 最好加个定时器给页面缓冲时间
      setTimeout(() => {
        // 获取锚点元素
        let anchor = document.querySelector('#' + selector)
        if (anchor) {
          anchor.scrollIntoView()
        }
      }, second)
    },
    changeSpecExpand(val) {
      this.isExpand = val
    },
    loginEmit() {
      this.dialogVisible = false
      this.$confirm('是否导入上一次填写的申请表内容到本次申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false
      }).then(res => {
        location.reload()
      }).catch(e => {
        this.reloadUserInfo = true
        this.$emit('loginEmit')
      })
    },
    getValidate() {
      let data = this.form
      if (this.moduleData.getFormatJson) {
        data = this.formatByJson(this.form, this.moduleData.getFormatJson)
      }
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      return new Promise(resolve => this.$refs.form.validate(resolve))
    },
    delCc(index) {
      this.form.orderLinkList.splice(index, 1)
    },
    addCc() {
      this.form.orderLinkList.push({
        linkName: '',
        linkPhone: '',
        linkEmail: '',
      })
    },
    querySearchAsync(queryString, cb, isNo) {
      const queryLength = isNo ? 4 : 2
      if (queryString && queryString.length > queryLength) {
        const data = {}
        if (isNo) {
          data.taxRegistrationNumber = queryString
        } else {
          data.customerName = queryString
        }
        this.apis.getCust(data).then(res => {
          if (res.data.items && res.data.items.length) {
            cb(res.data.items || [])
          } else {
            cb([])
          }
        }).catch(e => {
          cb([])
        })
      } else {
        cb([])
      }
    },
    handleSelect(item) { // 选中输入建议
      this.titleTipsVisible = false
      this.form.companyNameCn = item.customerNameCn
      this.form.companyAddressCn = item.addressCn
      this.form.companyNameEn = item.customerNameEn
      this.form.companyAddressEn = item.addressEn
    },
    titleFocus() {
      this.titleTipsVisible = !this.form.companyNameCn || this.form.companyNameCn.length < 3
    },
  }
}
</script>

<style scoped lang="scss">
.expand-btn {
  font-size: 14px;
  color: #878787;
  line-height: 18px;
  cursor: pointer;
  position: absolute;
  right: 0;
  font-weight: normal;
  img {
    vertical-align: bottom;
    margin-right: 5px;
  }
}
.login-btn {
  width: 95px;
  height: 28px;
  padding: 0;
  line-height: 26px;
  margin: 0 22px;
}
.login-tips {
  color: rgb(255, 48, 48);
  font-size: 12px;
}
.oiq-create-form .no-login .module-label {
  display: flex;
  align-items: center;
  width: 100%;
  &:before {
    top: 5px;
  }
}
.line-select {
  ::v-deep .el-form-item__label {
    font-size: 16px;
    font-weight: 700;
  }
}
  .apply-info-form, .link-info-form {
    padding-right: 46px;
  }
  .order-link-person {
    .sub-title {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      line-height: 1;
      margin-bottom: 14px;
    }
    .del-btn {
      color: #878787;
    }
    .add-btn {
      width: 142px;
      height: 36px;
      background: #FFFFFF;
      border: 1px solid #CA4300;
      border-radius: 4px;
      font-size: 14px;
      color: #CA4300;
      line-height: 34px;
      padding: 0;
      background: rgba(255, 102, 0, 0.05);
    }
    .phone-item {
      .el-input__suffix-inner {
        .code-btn {
          min-width: 100px;
          text-align: center;
          cursor: pointer;
          background: #fff;
          font-size: 14px;
          color: #CA4300;
          line-height: 38px;
          display: inline-block;
          position: relative;
          padding: 0 10px 0 5px;
          &:before {
            content: "";
            position: absolute;
            width: 1px;
            height: 29px;
            background: #CA4300;
            left: -10px;
            top: 5px;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
.apply-login {
  border-radius: 12px !important;
  .el-form-item {
    margin-bottom: 22px;
    padding: 0;
    border: none;
  }
}


.apply-login .el-dialog__body {
  padding: 0 !important;
}

.apply-login .el-dialog {
  width: 850px !important;
  height: 575px !important;
  margin-top: 0 !important;
}

.apply-login .el-dialog__header {
  border-bottom: none !important;
}

.apply-login .login-wrap {
  display: flex !important;
  width: 850px !important;
  min-height: 400px !important;
}

.apply-login .login-wrap .login-text {
  width: 270px !important;
  height: 100% !important;
  background: #fff !important;
  border-left: 1px solid #ccc !important;
  padding: 50px 0px 15px 75px !important;
  margin-bottom: 20px !important;
}

.apply-login .login-wrap .login-text .title {
  margin-bottom: 15px !important;
}

.apply-login .login-wrap .login-text .logo {
  margin-bottom: 20px !important;
}

.apply-login .el-input__suffix-inner {
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  color: #CA4300 !important;
  margin-right: 22px !important;
  cursor: pointer !important;
}

.apply-login .link-color {
  color: inherit !important;
}
/* 登录弹窗个性化配置 */
.apply-login .login-components .login-module {
  width: 540px;
}
.apply-login .login-components .login-module .side {
  display: none;
}
/* 登录弹窗个性化配置 */
</style>